import { jobLists } from "character";
import { EorzeaDataType, GameData, Job, Market, RelicData } from "enums";
import { Info } from "types/game";

export const arrItems = {
	[GameData.Item.AEOLIAN_SCIMITAR]: {
		name: GameData.Item.AEOLIAN_SCIMITAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.AEOLIAN_SCIMITAR,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 50,
					lodestoneID: "07f6b6e8be5",
					itemsRequired: [
						{ item: GameData.Item.BLUNT_AEOLIAN_SCIMITAR, qty: 1 },
						{ item: GameData.Item.DARKSTEEL_NUGGET, qty: 1 },
						{ item: GameData.Item.BASILISK_WHETSTONE, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 3 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 1670 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_1],
				jobs: [Job.PLD],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.BARBARIANS_BARDICHE]: {
		name: GameData.Item.BARBARIANS_BARDICHE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.BARBARIANS_BARDICHE,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 50,
					lodestoneID: "e0a074085b1",
					itemsRequired: [
						{ item: GameData.Item.BLOODY_BARDICHE_HEAD, qty: 1 },
						{ item: GameData.Item.DARKSTEEL_NUGGET, qty: 1 },
						{ item: GameData.Item.BASILISK_WHETSTONE, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 3 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 1810 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_1],
				jobs: [Job.WAR],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MADMANS_WHISPERING_ROD]: {
		name: GameData.Item.MADMANS_WHISPERING_ROD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.MADMANS_WHISPERING_ROD,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "3a5dcd108d9",
					itemsRequired: [
						{ item: GameData.Item.THAVNAIRIAN_MISTLETOE, qty: 1 },
						{ item: GameData.Item.GROWTH_FORMULA_DELTA, qty: 1 },
						{ item: GameData.Item.VAMPIRE_PLANT, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 2049 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_1],
				jobs: [Job.WHM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ERUDITES_PICATRIX_OF_HEALING]: {
		name: GameData.Item.ERUDITES_PICATRIX_OF_HEALING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ERUDITES_PICATRIX_OF_HEALING,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "49e7d5dfab4",
					itemsRequired: [
						{ item: GameData.Item.BLOODY_GRIMOIRE_BINDING, qty: 1 },
						{ item: GameData.Item.ENCHANTED_GOLD_INK, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 2201 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_1],
				jobs: [Job.SCH],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.WILDLINGS_CESTI]: {
		name: GameData.Item.WILDLINGS_CESTI,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.WILDLINGS_CESTI,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 50,
					lodestoneID: "7495adcb749",
					itemsRequired: [
						{ item: GameData.Item.BLOODY_CESTI_COVERS, qty: 1 },
						{ item: GameData.Item.DARKSTEEL_NUGGET, qty: 1 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 3 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 1740 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_1],
				jobs: [Job.MNK],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.CHAMPIONS_LANCE]: {
		name: GameData.Item.CHAMPIONS_LANCE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CHAMPIONS_LANCE,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 50,
					lodestoneID: "ae1cee7186f",
					itemsRequired: [
						{ item: GameData.Item.BLOODY_LANCE_HEAD, qty: 1 },
						{ item: GameData.Item.SPRUCE_LUMBER, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 3 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 1879 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_1],
				jobs: [Job.DRG],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.VAMPERS_KNIVES]: {
		name: GameData.Item.VAMPERS_KNIVES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.VAMPERS_KNIVES,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "6ba72635c64",
					itemsRequired: [
						{ item: GameData.Item.BLOODY_KNIFE_BLADES, qty: 1 },
						{ item: GameData.Item.POTENT_SLEEPING_POTION, qty: 1 },
						{ item: GameData.Item.ROSEWOOD_LUMBER, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9224 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_1],
				jobs: [Job.NIN],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.LONGARMS_COMPOSITE_BOW]: {
		name: GameData.Item.LONGARMS_COMPOSITE_BOW,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.LONGARMS_COMPOSITE_BOW,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 40,
					lodestoneID: "76db26731a6",
					itemsRequired: [
						{ item: GameData.Item.BLOODY_BOW_RIM, qty: 1 },
						{ item: GameData.Item.SPRUCE_LUMBER, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 3 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 1949 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_1],
				jobs: [Job.BRD],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.SANGUINE_SCEPTER]: {
		name: GameData.Item.SANGUINE_SCEPTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SANGUINE_SCEPTER,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 50,
					lodestoneID: "112a8f97e77",
					itemsRequired: [
						{ item: GameData.Item.PINPRICK_PEBBLE, qty: 1 },
						{ item: GameData.Item.DARKSTEEL_NUGGET, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 3 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 2102 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_1],
				jobs: [Job.BLM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ERUDITES_PICATRIX_OF_CASTING]: {
		name: GameData.Item.ERUDITES_PICATRIX_OF_CASTING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ERUDITES_PICATRIX_OF_CASTING,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "66cd94ee863",
					itemsRequired: [
						{ item: GameData.Item.BLOODY_GRIMOIRE_BINDING, qty: 1 },
						{ item: GameData.Item.ENCHANTED_GOLD_INK, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 2202 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_1],
				jobs: [Job.SMN],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.BATTLEDANCE_MATERIA_III]: {
		name: GameData.Item.BATTLEDANCE_MATERIA_III,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5681 },
			extraction: true,
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_2],
				jobs: [Job.PLD, Job.WAR],
				qtyPerJob: 2,
			},
		],
	},
	[GameData.Item.QUICKTONGUE_MATERIA_III]: {
		name: GameData.Item.QUICKTONGUE_MATERIA_III,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5721 },
			extraction: true,
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_2],
				jobs: [Job.WHM, Job.SCH],
				qtyPerJob: 2,
			},
		],
	},
	[GameData.Item.SAVAGE_AIM_MATERIA_III]: {
		name: GameData.Item.SAVAGE_AIM_MATERIA_III,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5671 },
			extraction: true,
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_2],
				jobs: [Job.MNK, Job.DRG],
				qtyPerJob: 2,
			},
		],
	},
	[GameData.Item.HEAVENS_EYE_MATERIA_III]: {
		name: GameData.Item.HEAVENS_EYE_MATERIA_III,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5666 },
			extraction: true,
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_2],
				jobs: [Job.NIN, Job.BRD],
				qtyPerJob: 2,
			},
		],
	},
	[GameData.Item.SAVAGE_MIGHT_MATERIA_III]: {
		name: GameData.Item.SAVAGE_MIGHT_MATERIA_III,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5676 },
			extraction: true,
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.CLASS_WEAPON, RelicData.Task.TASK_2],
				jobs: [Job.BLM, Job.SMN],
				qtyPerJob: 2,
			},
		],
	},
	[GameData.Item.QUENCHING_OIL]: {
		name: GameData.Item.QUENCHING_OIL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BASE_WEAPON, RelicData.Step.OIL, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.THAVNAIRIAN_MIST]: {
		name: GameData.Item.THAVNAIRIAN_MIST,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 15, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZENITH, RelicData.Step.MIST, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 3,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_LION]: {
		name: GameData.Item.ATMA_OF_THE_LION,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.OUTER_LA_NOSCEA] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_WATERBEARER]: {
		name: GameData.Item.ATMA_OF_THE_WATERBEARER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.UPPER_LA_NOSCEA] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_RAM]: {
		name: GameData.Item.ATMA_OF_THE_RAM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.MIDDLE_LA_NOSCEA] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_CRAB]: {
		name: GameData.Item.ATMA_OF_THE_CRAB,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.WESTERN_LA_NOSCEA] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_FISH]: {
		name: GameData.Item.ATMA_OF_THE_FISH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.LOWER_LA_NOSCEA] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_BULL]: {
		name: GameData.Item.ATMA_OF_THE_BULL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.EASTERN_THANALAN] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_SCALES]: {
		name: GameData.Item.ATMA_OF_THE_SCALES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.CENTRAL_THANALAN] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_7],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_TWINS]: {
		name: GameData.Item.ATMA_OF_THE_TWINS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.WESTERN_THANALAN] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_8],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_SCORPION]: {
		name: GameData.Item.ATMA_OF_THE_SCORPION,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.SOUTHERN_THANALAN] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_9],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_ARCHER]: {
		name: GameData.Item.ATMA_OF_THE_ARCHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.NORTH_SHROUD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_10],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_GOAT]: {
		name: GameData.Item.ATMA_OF_THE_GOAT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.EAST_SHROUD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_11],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ATMA_OF_THE_MAIDEN]: {
		name: GameData.Item.ATMA_OF_THE_MAIDEN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.CENTRAL_SHROUD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ATMA, RelicData.Step.ATMAS, RelicData.Task.TASK_12],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.SUPERIOR_ENCHANTED_INK]: {
		name: GameData.Item.SUPERIOR_ENCHANTED_INK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 25, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 25, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 25, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 25, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 25, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_NOVUS, RelicData.Step.SCROLL, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 3,
			},
		],
	},
	[GameData.Item.ALEXANDRITE]: {
		name: GameData.Item.ALEXANDRITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Mysterious Maps - These can be obtained from Auriana in Mor Dhona, or from the daily quest 'Morbid Motivation' also in Mor Dhona" },
				{ element: "p", text: "ARR FATEs (Must have Relic equipped)" },
				{ element: "p", text: "Bought with Allied Seals" },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_NOVUS, RelicData.Step.ALEXANDRITE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 75,
			},
		],
	},
	[GameData.Item.LIGHT]: {
		name: GameData.Item.LIGHT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "Gather 'Light' from various ARR activites (ARR Dungeons, ARR Trials, ARR FATEs, Treasure Hunt, Alexandrite Maps, The Wolves' Den and Frontlines)" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_NEXUS, RelicData.Step.LIGHT, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 2000,
			},
		],
	},
	[GameData.Item.BOMBARD_CORE]: {
		name: GameData.Item.BOMBARD_CORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 20000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 20000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 20000, currency: GameData.Currency.COMPANY_SEAL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.SKYLIGHT, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.ZODIUM, RelicData.Task.TASK_8],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.FLAWLESS_ALEXANDRITE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.BRAVES_SCROLL, RelicData.Task.TASK_7],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.BRONZE_LAKE_CRYSTAL]: {
		name: GameData.Item.BRONZE_LAKE_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { shops: [{ shop: GameData.Shop.JUNKMONGER, cost: [{ price: 100000, currency: GameData.Currency.GIL }] }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.SKYLIGHT, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.SACRED_SPRING_WATER]: {
		name: GameData.Item.SACRED_SPRING_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 200, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 200, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 200, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 200, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 200, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 200, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.SKYLIGHT, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.ZODIUM, RelicData.Task.TASK_9],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.FLAWLESS_ALEXANDRITE, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.BRAVES_SCROLL, RelicData.Task.TASK_9],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.HORN_OF_THE_BEAST]: {
		name: GameData.Item.HORN_OF_THE_BEAST,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.DZEMAEL_DARKHOLD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.SKYLIGHT, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.GOBMACHINE_BANGPLATE]: {
		name: GameData.Item.GOBMACHINE_BANGPLATE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.BRAYFLOX_HARD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.SKYLIGHT, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.NARASIMHA_HIDE]: {
		name: GameData.Item.NARASIMHA_HIDE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.HALATALI_HARD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.SKYLIGHT, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.SICKLE_FANG]: {
		name: GameData.Item.SICKLE_FANG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.SNOWCLOAK] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.SKYLIGHT, RelicData.Task.TASK_7],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.FURNACE_RING]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.FURNACE_RING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.FURNACE_RING,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 50,
					lodestoneID: "9130d6abd95",
					itemsRequired: [
						{ item: GameData.Item.AGED_EYE_OF_FIRE, qty: 1 },
						{ item: GameData.Item.BELAHDIAN_SILVER, qty: 1 },
						{ item: GameData.Item.BASILISK_WHETSTONE, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9510 },
		},
		used: [],
	},
	[GameData.Item.FURNACE_RING_HQ]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.FURNACE_RING_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.FURNACE_RING_HQ,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 50,
					lodestoneID: "9130d6abd95",
					itemsRequired: [
						{ item: GameData.Item.AGED_EYE_OF_FIRE, qty: 1 },
						{ item: GameData.Item.BELAHDIAN_SILVER, qty: 1 },
						{ item: GameData.Item.BASILISK_WHETSTONE, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9510 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.SKYLIGHT, RelicData.Task.TASK_8],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.PERFECT_FIREWOOD]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_FIREWOOD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_FIREWOOD,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 50,
					lodestoneID: "6dc973f7e54",
					itemsRequired: [
						{ item: GameData.Item.AGED_SPEAR_SHAFT, qty: 1 },
						{ item: GameData.Item.CYPRESS_LOG, qty: 2 },
						{ item: GameData.Item.GRENADE_ASH, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9511 },
		},
		used: [],
	},
	[GameData.Item.PERFECT_FIREWOOD_HQ]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_FIREWOOD_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_FIREWOOD_HQ,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 50,
					lodestoneID: "6dc973f7e54",
					itemsRequired: [
						{ item: GameData.Item.AGED_SPEAR_SHAFT, qty: 1 },
						{ item: GameData.Item.CYPRESS_LOG, qty: 2 },
						{ item: GameData.Item.GRENADE_ASH, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9511 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.SKYLIGHT, RelicData.Task.TASK_9],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ALLAGAN_RESIN]: {
		name: GameData.Item.ALLAGAN_RESIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { shops: [{ shop: GameData.Shop.MERCHANT_MENDER_SOUTH_THANALAN, cost: [{ price: 100000, currency: GameData.Currency.GIL }] }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.ZODIUM, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.VALE_BUBO]: {
		name: GameData.Item.VALE_BUBO,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.AURUM] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.ZODIUM, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.VOIDWEAVE]: {
		name: GameData.Item.VOIDWEAVE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.HAUKKE_MANOR_HARD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.ZODIUM, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.AMDAPOR_VELLUM]: {
		name: GameData.Item.AMDAPOR_VELLUM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.LOST_CITY_OF_AMDAPOR] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.ZODIUM, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.INDIGO_PEARL]: {
		name: GameData.Item.INDIGO_PEARL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.SASTASHA_HARD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.ZODIUM, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.PERFECT_MORTAR]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_MORTAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_MORTAR,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 50,
					lodestoneID: "0a574554dc3",
					itemsRequired: [
						{ item: GameData.Item.AGED_MORTAR_PIECES, qty: 1 },
						{ item: GameData.Item.BELAHDIAN_SILVER, qty: 1 },
						{ item: GameData.Item.MAHOGANY_LUMBER, qty: 1 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9512 },
		},
		used: [],
	},
	[GameData.Item.PERFECT_MORTAR_HQ]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_MORTAR_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_MORTAR_HQ,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 50,
					lodestoneID: "0a574554dc3",
					itemsRequired: [
						{ item: GameData.Item.AGED_MORTAR_PIECES, qty: 1 },
						{ item: GameData.Item.BELAHDIAN_SILVER, qty: 1 },
						{ item: GameData.Item.MAHOGANY_LUMBER, qty: 1 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9512 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.ZODIUM, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.PERFECT_PESTLE]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_PESTLE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_PESTLE,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 0,
					lodestoneID: "80a72bead39",
					itemsRequired: [
						{ item: GameData.Item.AGED_PESTLE_PIECES, qty: 1 },
						{ item: GameData.Item.CYPRESS_LOG, qty: 2 },
						{ item: GameData.Item.PEISTE_LEATHER, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9513 },
		},
		used: [],
	},
	[GameData.Item.PERFECT_PESTLE_HQ]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_PESTLE_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_PESTLE_HQ,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 0,
					lodestoneID: "80a72bead39",
					itemsRequired: [
						{ item: GameData.Item.AGED_PESTLE_PIECES, qty: 1 },
						{ item: GameData.Item.CYPRESS_LOG, qty: 2 },
						{ item: GameData.Item.PEISTE_LEATHER, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9513 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.ZODIUM, RelicData.Task.TASK_7],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.BRASS_KETTLE]: {
		name: GameData.Item.BRASS_KETTLE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { shops: [{ shop: GameData.Shop.TOOL_SUPPLIER_MENDER, cost: [{ price: 100000, currency: GameData.Currency.GIL }] }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.FLAWLESS_ALEXANDRITE, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.LOST_TREASURE_OF_AMDAPOR]: {
		name: GameData.Item.LOST_TREASURE_OF_AMDAPOR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.AMDAPOR_KEEP] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.FLAWLESS_ALEXANDRITE, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.LOST_TREASURE_OF_PHAROS_SIRIUS]: {
		name: GameData.Item.LOST_TREASURE_OF_PHAROS_SIRIUS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.PHAROS_SIRIUS] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.FLAWLESS_ALEXANDRITE, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.LOST_TREASURE_OF_TAM_TARA]: {
		name: GameData.Item.LOST_TREASURE_OF_TAM_TARA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.TAM_TARA_HARD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.FLAWLESS_ALEXANDRITE, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.LOST_TREASURE_OF_STONE_VIGIL]: {
		name: GameData.Item.LOST_TREASURE_OF_STONE_VIGIL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.STONE_VIGIL_HARD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.FLAWLESS_ALEXANDRITE, RelicData.Task.TASK_7],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.TAILOR_MADE_EEL_PIE]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.TAILOR_MADE_EEL_PIE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.TAILOR_MADE_EEL_PIE_HQ,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 50,
					lodestoneID: "323eb2ddf17",
					itemsRequired: [
						{ item: GameData.Item.VINTAGE_COOKING_SHERRY, qty: 1 },
						{ item: GameData.Item.WORM_OF_NYM, qty: 1 },
						{ item: GameData.Item.PIE_DOUGH, qty: 1 },
						{ item: GameData.Item.SMOOTH_BUTTER, qty: 1 },
						{ item: GameData.Item.BLACK_PEPPER, qty: 1 },
						{ item: GameData.Item.CLOVES, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9516 },
		},
		used: [],
	},
	[GameData.Item.TAILOR_MADE_EEL_PIE_HQ]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.TAILOR_MADE_EEL_PIE_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.TAILOR_MADE_EEL_PIE_HQ,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 50,
					lodestoneID: "323eb2ddf17",
					itemsRequired: [
						{ item: GameData.Item.VINTAGE_COOKING_SHERRY, qty: 1 },
						{ item: GameData.Item.WORM_OF_NYM, qty: 1 },
						{ item: GameData.Item.PIE_DOUGH, qty: 1 },
						{ item: GameData.Item.SMOOTH_BUTTER, qty: 1 },
						{ item: GameData.Item.BLACK_PEPPER, qty: 1 },
						{ item: GameData.Item.CLOVES, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9516 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.FLAWLESS_ALEXANDRITE, RelicData.Task.TASK_8],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.PERFECT_CLOTH]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_CLOTH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_CLOTH,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 50,
					lodestoneID: "320f8397d7a",
					itemsRequired: [
						{ item: GameData.Item.STAINED_CLOTH, qty: 1 },
						{ item: GameData.Item.PUMICE, qty: 2 },
						{ item: GameData.Item.LINEN_YARN, qty: 1 },
						{ item: GameData.Item.EFFERVESCENT_WATER, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9517 },
		},
		used: [],
	},
	[GameData.Item.PERFECT_CLOTH_HQ]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_CLOTH_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_CLOTH_HQ,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 50,
					lodestoneID: "320f8397d7a",
					itemsRequired: [
						{ item: GameData.Item.STAINED_CLOTH, qty: 1 },
						{ item: GameData.Item.PUMICE, qty: 2 },
						{ item: GameData.Item.LINEN_YARN, qty: 1 },
						{ item: GameData.Item.EFFERVESCENT_WATER, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9517 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.FLAWLESS_ALEXANDRITE, RelicData.Task.TASK_9],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.TONBERRY_KING_BLOOD]: {
		name: GameData.Item.TONBERRY_KING_BLOOD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.WANDERERS] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.BRAVES_SCROLL, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ROYAL_GIGANT_BLOOD]: {
		name: GameData.Item.ROYAL_GIGANT_BLOOD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.COPPERBELL_HARD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.BRAVES_SCROLL, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.KRAKEN_BLOOD]: {
		name: GameData.Item.KRAKEN_BLOOD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.HULLBREAKER] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.BRAVES_SCROLL, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.VICEGERENT_BLOOD]: {
		name: GameData.Item.VICEGERENT_BLOOD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { dungeons: [GameData.Dungeon.QARN_HARD] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.BRAVES_SCROLL, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.PERFECT_VELLUM]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_VELLUM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_VELLUM,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 50,
					lodestoneID: "128be3afd40",
					itemsRequired: [
						{ item: GameData.Item.AGED_VELLUM, qty: 1 },
						{ item: GameData.Item.PUMICE, qty: 2 },
						{ item: GameData.Item.SHARK_OIL, qty: 1 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9514 },
		},
		used: [],
	},
	[GameData.Item.PERFECT_VELLUM_HQ]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_VELLUM_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_VELLUM_HQ,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 50,
					lodestoneID: "128be3afd40",
					itemsRequired: [
						{ item: GameData.Item.AGED_VELLUM, qty: 1 },
						{ item: GameData.Item.PUMICE, qty: 2 },
						{ item: GameData.Item.SHARK_OIL, qty: 1 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9514 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.BRAVES_SCROLL, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.PERFECT_POUNCE]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_POUNCE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_POUNCE,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "f9e57147805",
					itemsRequired: [
						{ item: GameData.Item.DRIED_ETHER, qty: 1 },
						{ item: GameData.Item.AETHERLOUSE, qty: 1 },
						{ item: GameData.Item.ELECTRUM_SAND, qty: 1 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 2 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9515 },
		},
		used: [],
	},
	[GameData.Item.PERFECT_POUNCE_HQ]: { // Obtained should match between normal and HQ versions
		name: GameData.Item.PERFECT_POUNCE_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERFECT_POUNCE_HQ,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "f9e57147805",
					itemsRequired: [
						{ item: GameData.Item.DRIED_ETHER, qty: 1 },
						{ item: GameData.Item.AETHERLOUSE, qty: 1 },
						{ item: GameData.Item.ELECTRUM_SAND, qty: 1 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 2 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 9515 },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.BRAVES_SCROLL, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.FURITE_SAND]: {
		name: GameData.Item.FURITE_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { shops: [{ shop: GameData.Shop.MERCHANT_MENDER_COERTHAS_CENTRAL_HIGHLANDS, cost: [{ price: 100000, currency: GameData.Currency.GIL }] }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_BRAVES, RelicData.Step.BRAVES_SCROLL, RelicData.Task.TASK_8],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_RAM]: {
		name: GameData.Item.MAHATMA_OF_THE_RAM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_BULL]: {
		name: GameData.Item.MAHATMA_OF_THE_BULL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_TWINS]: {
		name: GameData.Item.MAHATMA_OF_THE_TWINS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_CRAB]: {
		name: GameData.Item.MAHATMA_OF_THE_CRAB,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_LION]: {
		name: GameData.Item.MAHATMA_OF_THE_LION,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_MAIDEN]: {
		name: GameData.Item.MAHATMA_OF_THE_MAIDEN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_SCALES]: {
		name: GameData.Item.MAHATMA_OF_THE_SCALES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_7],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_SCORPION]: {
		name: GameData.Item.MAHATMA_OF_THE_SCORPION,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_8],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_ARCHER]: {
		name: GameData.Item.MAHATMA_OF_THE_ARCHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_9],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_GOAT]: {
		name: GameData.Item.MAHATMA_OF_THE_GOAT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_10],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_WATERBEARER]: {
		name: GameData.Item.MAHATMA_OF_THE_WATERBEARER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_11],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAHATMA_OF_THE_FISH]: {
		name: GameData.Item.MAHATMA_OF_THE_FISH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "These need to be upgraded similar to 'Light' from the Nexus upgrade - 40 Points are required - Points are obtained from ARR dungeons, trials, raids" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ZODIAC, RelicData.Part.WEAPON_ZETA, RelicData.Step.SOUL, RelicData.Task.TASK_12],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ZODIAC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.DARKSTEEL_NUGGET]: {
		name: GameData.Item.DARKSTEEL_NUGGET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5060 },
			recipes: [
				{
					itemMade: GameData.Item.DARKSTEEL_NUGGET,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DARKSTEEL_ORE, qty: 3 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.DARKSTEEL_NUGGET,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DARKSTEEL_ORE, qty: 3 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 3 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.BASILISK_WHETSTONE]: {
		name: GameData.Item.BASILISK_WHETSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5262 },
			recipes: [
				{
					itemMade: GameData.Item.BASILISK_WHETSTONE,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 40,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.BASILISK_EGG, qty: 1 },
						{ item: GameData.Item.WIND_SHARD, qty: 5 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.FIRE_SHARD]: {
		name: GameData.Item.FIRE_SHARD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Shards can be obtained from many places, for example" },
				{ element: "li", text: "Level 1-50 gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Gardening" },
			],
			markets: { [Market.UNIVERSALIS]: 2 },
		},
		used: [],
	},
	[GameData.Item.ICE_SHARD]: {
		name: GameData.Item.ICE_SHARD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Shards can be obtained from many places, for example" },
				{ element: "li", text: "Level 1-50 gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Gardening" },
			],
			markets: { [Market.UNIVERSALIS]: 3 },
		},
		used: [],
	},
	[GameData.Item.WIND_SHARD]: {
		name: GameData.Item.WIND_SHARD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Shards can be obtained from many places, for example" },
				{ element: "li", text: "Level 1-50 gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Gardening" },
			],
			markets: { [Market.UNIVERSALIS]: 4 },
		},
		used: [],
	},
	[GameData.Item.EARTH_SHARD]: {
		name: GameData.Item.EARTH_SHARD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Shards can be obtained from many places, for example" },
				{ element: "li", text: "Level 1-50 gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Gardening" },
			],
			markets: { [Market.UNIVERSALIS]: 5 },
		},
		used: [],
	},
	[GameData.Item.LIGHTNING_SHARD]: {
		name: GameData.Item.LIGHTNING_SHARD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Shards can be obtained from many places, for example" },
				{ element: "li", text: "Level 1-50 gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Gardening" },
			],
			markets: { [Market.UNIVERSALIS]: 6 },
		},
		used: [],
	},
	[GameData.Item.WATER_SHARD]: {
		name: GameData.Item.WATER_SHARD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Shards can be obtained from many places, for example" },
				{ element: "li", text: "Level 1-50 gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Gardening" },
			],
			markets: { [Market.UNIVERSALIS]: 7 },
		},
		used: [],
	},
	[GameData.Item.FIRE_CRYSTAL]: {
		name: GameData.Item.FIRE_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Crystals can be obtained from many places, for example" },
				{ element: "li", text: "Level 25+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 8 },
		},
		used: [],
	},
	[GameData.Item.ICE_CRYSTAL]: {
		name: GameData.Item.ICE_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Crystals can be obtained from many places, for example" },
				{ element: "li", text: "Level 25+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 9 },
		},
		used: [],
	},
	[GameData.Item.WIND_CRYSTAL]: {
		name: GameData.Item.WIND_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Crystals can be obtained from many places, for example" },
				{ element: "li", text: "Level 25+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 10 },
		},
		used: [],
	},
	[GameData.Item.EARTH_CRYSTAL]: {
		name: GameData.Item.EARTH_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Crystals can be obtained from many places, for example" },
				{ element: "li", text: "Level 25+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 11 },
		},
		used: [],
	},
	[GameData.Item.LIGHTNING_CRYSTAL]: {
		name: GameData.Item.LIGHTNING_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Crystals can be obtained from many places, for example" },
				{ element: "li", text: "Level 25+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 12 },
		},
		used: [],
	},
	[GameData.Item.WATER_CRYSTAL]: {
		name: GameData.Item.WATER_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Crystals can be obtained from many places, for example" },
				{ element: "li", text: "Level 25+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 13 },
		},
		used: [],
	},
	[GameData.Item.FIRE_CLUSTER]: {
		name: GameData.Item.FIRE_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Clusters can be obtained from many places, for example" },
				{ element: "li", text: "Level 50+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 14 },
		},
		used: [],
	},
	[GameData.Item.ICE_CLUSTER]: {
		name: GameData.Item.ICE_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Clusters can be obtained from many places, for example" },
				{ element: "li", text: "Level 50+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 15 },
		},
		used: [],
	},
	[GameData.Item.WIND_CLUSTER]: {
		name: GameData.Item.WIND_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Clusters can be obtained from many places, for example" },
				{ element: "li", text: "Level 50+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 16 },
		},
		used: [],
	},
	[GameData.Item.EARTH_CLUSTER]: {
		name: GameData.Item.EARTH_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Clusters can be obtained from many places, for example" },
				{ element: "li", text: "Level 50+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 17 },
		},
		used: [],
	},
	[GameData.Item.LIGHTNING_CLUSTER]: {
		name: GameData.Item.LIGHTNING_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Clusters can be obtained from many places, for example" },
				{ element: "li", text: "Level 50+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 18 },
		},
		used: [],
	},
	[GameData.Item.WATER_CLUSTER]: {
		name: GameData.Item.WATER_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Clusters can be obtained from many places, for example" },
				{ element: "li", text: "Level 50+ gathering nodes" },
				{ element: "li", text: "Sprites / Elementals of the relevant element" },
				{ element: "li", text: "Aetherial Reduction" },
			],
			markets: { [Market.UNIVERSALIS]: 19 },
		},
		used: [],
	},
	[GameData.Item.BASILISK_EGG]: {
		name: GameData.Item.BASILISK_EGG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.BASILISK],
			markets: { [Market.UNIVERSALIS]: 5263 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.BLUEFOG, x: 23, y: 24 } }],
		},
		used: [],
	},
	[GameData.Item.BLUNT_AEOLIAN_SCIMITAR]: {
		name: GameData.Item.BLUNT_AEOLIAN_SCIMITAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 1636 },
			shops: [{ shop: GameData.Shop.JUNKMONGER, cost: [{ price: 3168, currency: GameData.Currency.GIL }] }],
			duties: {
				dungeons: [GameData.Dungeon.WANDERERS],
				leves: [GameData.Leve.ID_RATHER_BE_DIGGING, GameData.Leve.I_MAUL_RIGHT, GameData.Leve.NO_REFUNDS_ONLY_EXCHANGES, GameData.Leve.POP_THAT_TOP, GameData.Leve.TALON_TERRORS, GameData.Leve.YOU_STAY_ON_THAT_SIDE],
			},
		},
		used: [],
	},
	[GameData.Item.DARKSTEEL_ORE]: {
		name: GameData.Item.DARKSTEEL_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5121 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.HALDRATHS_MARCH, x: 27, y: 20 }, timedNode: true, times: ["1 AM"] }],
		},
		used: [],
	},
	[GameData.Item.BLOODY_BARDICHE_HEAD]: {
		name: GameData.Item.BLOODY_BARDICHE_HEAD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5566 },
			duties: {
				dungeons: [GameData.Dungeon.WANDERERS],
				leves: [GameData.Leve.ID_RATHER_BE_DIGGING, GameData.Leve.I_MAUL_RIGHT, GameData.Leve.NO_REFUNDS_ONLY_EXCHANGES, GameData.Leve.POP_THAT_TOP, GameData.Leve.TALON_TERRORS, GameData.Leve.YOU_STAY_ON_THAT_SIDE],
			},
		},
		used: [],
	},
	[GameData.Item.THAVNAIRIAN_MISTLETOE]: {
		name: GameData.Item.THAVNAIRIAN_MISTLETOE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5537 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.WHITEBRIM, x: 7, y: 11 }, timedNode: true, times: ["5 PM"] }],
			duties: {
				leves: [
					GameData.Leve.MATTER_OF_VITAL_IMPORTANCE,
					GameData.Leve.MAKE_UP_YOUR_MIND_OR_ELSE,
					GameData.Leve.NOT_TAKING_NO_FOR_AN_ANSWER,
					GameData.Leve.QUIT_YOUR_JIBJAB,
					GameData.Leve.SHUT_UP_ALREADY,
					GameData.Leve.SLEEPLESS_IN_SILVERTEAR,
				],
			},
		},
		used: [],
	},
	[GameData.Item.GROWTH_FORMULA_DELTA]: {
		name: GameData.Item.GROWTH_FORMULA_DELTA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5473 },
			recipes: [
				{
					itemMade: GameData.Item.GROWTH_FORMULA_DELTA,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.TRILLIUM_BULB, qty: 1 },
						{ item: GameData.Item.QUICKSILVER, qty: 1 },
						{ item: GameData.Item.ROCK_SALT, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 3 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.VAMPIRE_PLANT]: {
		name: GameData.Item.VAMPIRE_PLANT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5547 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.DRAGONHEAD, x: 28, y: 25 }, timedNode: true, times: ["1 PM"] }],
		},
		used: [],
	},
	[GameData.Item.BLOODY_GRIMOIRE_BINDING]: {
		name: GameData.Item.BLOODY_GRIMOIRE_BINDING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5569 },
			duties: {
				dungeons: [GameData.Dungeon.WANDERERS],
				leves: [
					GameData.Leve.MATTER_OF_VITAL_IMPORTANCE,
					GameData.Leve.MAKE_UP_YOUR_MIND_OR_ELSE,
					GameData.Leve.NOT_TAKING_NO_FOR_AN_ANSWER,
					GameData.Leve.QUIT_YOUR_JIBJAB,
					GameData.Leve.SHUT_UP_ALREADY,
					GameData.Leve.SLEEPLESS_IN_SILVERTEAR,
				],
			},
		},
		used: [],
	},
	[GameData.Item.ENCHANTED_GOLD_INK]: {
		name: GameData.Item.ENCHANTED_GOLD_INK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5480 },
			recipes: [
				{
					itemMade: GameData.Item.ENCHANTED_GOLD_INK,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.GOLD_SAND, qty: 3 },
						{ item: GameData.Item.SPOKEN_BLOOD, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 3 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.BLOODY_CESTI_COVERS]: {
		name: GameData.Item.BLOODY_CESTI_COVERS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5567 },
			duties: {
				dungeons: [GameData.Dungeon.WANDERERS],
				leves: [GameData.Leve.FUSS_IN_BOOTS, GameData.Leve.HANDLE_WITH_CARE, GameData.Leve.HOLD_ON_TIGHT, GameData.Leve.SPELLING_ME_SOFTLY, GameData.Leve.TENDERFOOT_MOMENTS, GameData.Leve.TOO_HOT_TO_HANDLE],
			},
		},
		used: [],
	},
	[GameData.Item.BLOODY_LANCE_HEAD]: {
		name: GameData.Item.BLOODY_LANCE_HEAD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5565 },
			duties: {
				dungeons: [GameData.Dungeon.WANDERERS],
				leves: [
					GameData.Leve.BOW_DOWN_TO_MAGIC,
					GameData.Leve.BOWING_TO_GREATER_POWER,
					GameData.Leve.CLOGS_OF_WAR,
					GameData.Leve.INCANT_NOW_THINK_LATER,
					GameData.Leve.TRIDENT_AND_ERROR,
					GameData.Leve.YOU_DO_THE_HEAVY_LIFTING,
				],
			},
		},
		used: [],
	},
	[GameData.Item.SPRUCE_LUMBER]: {
		name: GameData.Item.SPRUCE_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5378 },
			recipes: [
				{
					itemMade: GameData.Item.SPRUCE_LUMBER,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SPRUCE_LOG, qty: 3 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 3 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.SPRUCE_LOG]: {
		name: GameData.Item.SPRUCE_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5395 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.PROVIDENCE_POINT, x: 27, y: 13 }, timedNode: true, times: ["9 AM"] }],
		},
		used: [],
	},
	[GameData.Item.BLOODY_KNIFE_BLADES]: {
		name: GameData.Item.BLOODY_KNIFE_BLADES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 9374 },
			duties: {
				dungeons: [GameData.Dungeon.WANDERERS],
				leves: [
					GameData.Leve.MATTER_OF_VITAL_IMPORTANCE,
					GameData.Leve.MAKE_UP_YOUR_MIND_OR_ELSE,
					GameData.Leve.NOT_TAKING_NO_FOR_AN_ANSWER,
					GameData.Leve.QUIT_YOUR_JIBJAB,
					GameData.Leve.SHUT_UP_ALREADY,
					GameData.Leve.SLEEPLESS_IN_SILVERTEAR,
				],
			},
		},
		used: [],
	},
	[GameData.Item.POTENT_SLEEPING_POTION]: {
		name: GameData.Item.POTENT_SLEEPING_POTION,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4587 },
			recipes: [
				{
					itemMade: GameData.Item.POTENT_SLEEPING_POTION,
					qtyMade: 3,
					crafter: Job.ALC,
					level: 48,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.QUICKSILVER, qty: 1 },
						{ item: GameData.Item.OCHU_VINE, qty: 1 },
						{ item: GameData.Item.DESERT_SAFFRON, qty: 1 },
						{ item: GameData.Item.WATER_SHARD, qty: 6 },
						{ item: GameData.Item.LIGHTNING_SHARD, qty: 6 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.ROSEWOOD_LUMBER]: {
		name: GameData.Item.ROSEWOOD_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5376 },
			recipes: [
				{
					itemMade: GameData.Item.ROSEWOOD_LUMBER,
					qtyMade: 3,
					crafter: Job.CRP,
					level: 45,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ROSEWOOD_LOG, qty: 3 },
						{ item: GameData.Item.WIND_SHARD, qty: 6 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.BLOODY_BOW_RIM]: {
		name: GameData.Item.BLOODY_BOW_RIM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5568 },
			duties: {
				dungeons: [GameData.Dungeon.WANDERERS],
				leves: [
					GameData.Leve.BOW_DOWN_TO_MAGIC,
					GameData.Leve.BOWING_TO_GREATER_POWER,
					GameData.Leve.CLOGS_OF_WAR,
					GameData.Leve.INCANT_NOW_THINK_LATER,
					GameData.Leve.TRIDENT_AND_ERROR,
					GameData.Leve.YOU_DO_THE_HEAVY_LIFTING,
				],
			},
		},
		used: [],
	},
	[GameData.Item.PINPRICK_PEBBLE]: {
		name: GameData.Item.PINPRICK_PEBBLE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5206 },
			duties: {
				dungeons: [GameData.Dungeon.WANDERERS],
				leves: [GameData.Leve.GOLD_IS_SO_LAST_YEAR, GameData.Leve.GREEN_AND_BEAR_IT, GameData.Leve.LIGHT_IN_THE_DARKNESS, GameData.Leve.SEW_NOT_DOING_THIS, GameData.Leve.SWEET_CHARITY, GameData.Leve.BIG_RED],
			},
		},
		used: [],
	},
	[GameData.Item.AGED_EYE_OF_FIRE]: {
		name: GameData.Item.AGED_EYE_OF_FIRE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { desynthesis: [GameData.Item.AGED_RING, GameData.Item.FURNACE_RING] },
		used: [],
	},
	[GameData.Item.BELAHDIAN_SILVER]: {
		name: GameData.Item.BELAHDIAN_SILVER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { desynthesis: [GameData.Item.FURNACE_RING, GameData.Item.PERFECT_MORTAR] },
		used: [],
	},
	[GameData.Item.AGED_SPEAR_SHAFT]: {
		name: GameData.Item.AGED_SPEAR_SHAFT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { desynthesis: [GameData.Item.AGED_SPEAR, GameData.Item.PERFECT_FIREWOOD] },
		used: [],
	},
	[GameData.Item.CYPRESS_LOG]: {
		name: GameData.Item.CYPRESS_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 9518 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.BENTBRANCH, x: 24, y: 31 }, timedNode: true, times: ["10 AM"] }],
		},
		used: [],
	},
	[GameData.Item.GRENADE_ASH]: {
		name: GameData.Item.GRENADE_ASH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5526 },
			enemies: [GameData.Enemy.GRENADE],
			gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.BLUEFOG, x: 22, y: 28 } }],
			shops: [{ shop: GameData.Shop.ZRANMAIA, cost: [{ price: 216, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.AGED_MORTAR_PIECES]: {
		name: GameData.Item.AGED_MORTAR_PIECES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { desynthesis: [GameData.Item.AGED_MORTAR, GameData.Item.PERFECT_MORTAR] },
		used: [],
	},
	[GameData.Item.MAHOGANY_LUMBER]: {
		name: GameData.Item.MAHOGANY_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5374 },
			recipes: [
				{
					itemMade: GameData.Item.MAHOGANY_LUMBER,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 39,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.MAHOGANY_LOG, qty: 3 },
						{ item: GameData.Item.WIND_SHARD, qty: 5 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.AGED_PESTLE_PIECES]: {
		name: GameData.Item.AGED_PESTLE_PIECES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { desynthesis: [GameData.Item.AGED_PESTLE, GameData.Item.PERFECT_PESTLE] },
		used: [],
	},
	[GameData.Item.PEISTE_LEATHER]: {
		name: GameData.Item.PEISTE_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5284 },
			recipes: [
				{
					itemMade: GameData.Item.PEISTE_LEATHER,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 38,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.PEISTE_SKIN, qty: 1 },
						{ item: GameData.Item.BLACK_ALUMEN, qty: 1 },
						{ item: GameData.Item.EARTH_SHARD, qty: 4 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.VINTAGE_COOKING_SHERRY]: {
		name: GameData.Item.VINTAGE_COOKING_SHERRY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 9528 },
			desynthesis: [GameData.Item.AGED_DECANTER, GameData.Item.TAILOR_MADE_EEL_PIE],
		},
		used: [],
	},
	[GameData.Item.WORM_OF_NYM]: {
		name: GameData.Item.WORM_OF_NYM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 7916 },
			fishingHoles: [{ fish: GameData.Fish.WORM_OF_NYM, hole: GameData.Fishing.BRONZE_LAKE_SHALLOWS, bait: [GameData.Bait.BUTTERWORM] }],
		},
		used: [],
	},
	[GameData.Item.PIE_DOUGH]: {
		name: GameData.Item.PIE_DOUGH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4861 },
			recipes: [
				{
					itemMade: GameData.Item.PIE_DOUGH,
					qtyMade: 6,
					crafter: Job.CUL,
					level: 14,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SUNSET_WHEAT_FLOUR, qty: 1 },
						{ item: GameData.Item.TABLE_SALT, qty: 1 },
						{ item: GameData.Item.MINERAL_WATER, qty: 1 },
						{ item: GameData.Item.FIRE_SHARD, qty: 1 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.SMOOTH_BUTTER]: {
		name: GameData.Item.SMOOTH_BUTTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4853 },
			recipes: [
				{
					itemMade: GameData.Item.SMOOTH_BUTTER,
					qtyMade: 5,
					crafter: Job.CUL,
					level: 7,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.BUFFALO_MILK, qty: 2 },
						{ item: GameData.Item.FIRE_SHARD, qty: 1 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SAHAGIN_VENDOR, cost: [{ price: 2, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.BLACK_PEPPER]: {
		name: GameData.Item.BLACK_PEPPER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4830 },
			gathering: [{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.CLUTCH, x: 25, y: 20 } }],
			shops: [
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 13, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.JOSSY, cost: [{ price: 13, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 13, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SAHAGIN_VENDOR, cost: [{ price: 13, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.CLOVES]: {
		name: GameData.Item.CLOVES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4831 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.SPINELESS_BASIN, x: 23, y: 26 } }],
			shops: [
				{ shop: GameData.Shop.ESMENET, cost: [{ price: 16, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.KOBOLD_VENDOR, cost: [{ price: 16, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.TANIE, cost: [{ price: 16, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.STAINED_CLOTH]: {
		name: GameData.Item.STAINED_CLOTH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { desynthesis: [GameData.Item.AGED_ROBE, GameData.Item.PERFECT_CLOTH] },
		used: [],
	},
	[GameData.Item.PUMICE]: {
		name: GameData.Item.PUMICE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 9519 },
			gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.RAINCATCHER_GULLY, x: 19, y: 28 }, timedNode: true, times: ["1 AM"] }],
		},
		used: [],
	},
	[GameData.Item.LINEN_YARN]: {
		name: GameData.Item.LINEN_YARN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5336 },
			recipes: [
				{
					itemMade: GameData.Item.LINEN_YARN,
					qtyMade: 2,
					crafter: Job.WVR,
					level: 32,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.FLAX, qty: 2 },
						{ item: GameData.Item.LIGHTNING_SHARD, qty: 2 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SYLPHIC_VENDOR, cost: [{ price: 186, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.EFFERVESCENT_WATER]: {
		name: GameData.Item.EFFERVESCENT_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5491 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.UPPER_PATHS, x: 16, y: 20 } }],
		},
		used: [],
	},
	[GameData.Item.AGED_VELLUM]: {
		name: GameData.Item.AGED_VELLUM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { desynthesis: [GameData.Item.AGED_GRIMOIRE, GameData.Item.PERFECT_VELLUM] },
		used: [],
	},
	[GameData.Item.SHARK_OIL]: {
		name: GameData.Item.SHARK_OIL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5486 },
			recipes: [
				{
					itemMade: GameData.Item.SHARK_OIL,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 41,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.HAMMERHEAD_SHARK, qty: 1 },
						{ item: GameData.Item.SILVER_SHARK, qty: 1 },
						{ item: GameData.Item.WATER_SHARD, qty: 5 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.DRIED_ETHER]: {
		name: GameData.Item.DRIED_ETHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { desynthesis: [GameData.Item.AGED_PHIAL, GameData.Item.PERFECT_POUNCE] },
		used: [],
	},
	[GameData.Item.AETHERLOUSE]: {
		name: GameData.Item.AETHERLOUSE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 7951 },
			fishingHoles: [{ fish: GameData.Fish.AETHERLOUSE, hole: GameData.Fishing.NORTH_SILVERTEAR, bait: [GameData.Bait.GLOWWORM] }],
		},
		used: [],
	},
	[GameData.Item.ELECTRUM_SAND]: {
		name: GameData.Item.ELECTRUM_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5272 },
			gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.BRONZE_LAKE, x: 28, y: 22 } }],
		},
		used: [],
	},
	[GameData.Item.TRILLIUM_BULB]: {
		name: GameData.Item.TRILLIUM_BULB,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5546 },
			gathering: [{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.HONEY_YARD, x: 14, y: 23 }, timedNode: true, times: ["9 PM"] }],
		},
		used: [],
	},
	[GameData.Item.QUICKSILVER]: {
		name: GameData.Item.QUICKSILVER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5489 },
			recipes: [
				{
					itemMade: GameData.Item.QUICKSILVER,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 1,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.CINNABAR, qty: 2 },
						{ item: GameData.Item.WATER_SHARD, qty: 1 },
					],
				},
			],
			shops: [
				{ shop: GameData.Shop.ENGERRAND, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.FRIDURIH, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.KOBOLD_VENDOR, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ORHOYOD, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.PASDEVILLET, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SHIRAKASHI, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.TRAVELING_MATERIAL_SUPPLIER, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.VRAL, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.ROCK_SALT]: {
		name: GameData.Item.ROCK_SALT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5518 },
			gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.BLACK_BRUSH, x: 15, y: 23 } }],
			shops: [
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ENGERRAND, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ESMENET, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.FRIDURIH, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.JOSSY, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ORHOYOD, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SHIRAKASHI, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.TRAVELING_MATERIAL_SUPPLIER, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.VRAL, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.GOLD_SAND]: {
		name: GameData.Item.GOLD_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5273 },
			gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.YUGRAM_RIVER, x: 26, y: 23 }, timedNode: true, times: ["5 AM"] }],
		},
		used: [],
	},
	[GameData.Item.SPOKEN_BLOOD]: {
		name: GameData.Item.SPOKEN_BLOOD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5494 },
			enemies: [GameData.Enemy.LESSER_KALONG],
		},
		used: [],
	},
	[GameData.Item.OCHU_VINE]: {
		name: GameData.Item.OCHU_VINE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5555 },
			enemies: [GameData.Enemy.MILKROOT_CLUSTER, GameData.Enemy.OCHU],
		},
		used: [],
	},
	[GameData.Item.DESERT_SAFFRON]: {
		name: GameData.Item.DESERT_SAFFRON,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4843 },
			gathering: [{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.BROKEN_WATER, x: 21, y: 9 } }],
		},
		used: [],
	},
	[GameData.Item.ROSEWOOD_LOG]: {
		name: GameData.Item.ROSEWOOD_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5393 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.BRAMBLE_PATCH, x: 17, y: 23 } }],
		},
		used: [],
	},
	[GameData.Item.AGED_DECANTER]: {
		name: GameData.Item.AGED_DECANTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.MERCHANT_MENDER_SILVER_BAZAAR, cost: [{ price: 3000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.AGED_GRIMOIRE]: {
		name: GameData.Item.AGED_GRIMOIRE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.MERCHANT_MENDER_SILVER_BAZAAR, cost: [{ price: 3000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.AGED_MORTAR]: {
		name: GameData.Item.AGED_MORTAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.MERCHANT_MENDER_SILVER_BAZAAR, cost: [{ price: 3000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.AGED_PESTLE]: {
		name: GameData.Item.AGED_PESTLE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.MERCHANT_MENDER_SILVER_BAZAAR, cost: [{ price: 3000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.AGED_PHIAL]: {
		name: GameData.Item.AGED_PHIAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.MERCHANT_MENDER_SILVER_BAZAAR, cost: [{ price: 3000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.AGED_RING]: {
		name: GameData.Item.AGED_RING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.MERCHANT_MENDER_SILVER_BAZAAR, cost: [{ price: 3000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.AGED_ROBE]: {
		name: GameData.Item.AGED_ROBE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.MERCHANT_MENDER_SILVER_BAZAAR, cost: [{ price: 3000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.AGED_SPEAR]: {
		name: GameData.Item.AGED_SPEAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.MERCHANT_MENDER_SILVER_BAZAAR, cost: [{ price: 3000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.MAHOGANY_LOG]: {
		name: GameData.Item.MAHOGANY_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5391 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.RAINCATCHER_GULLY, x: 19, y: 26 } }],
		},
		used: [],
	},
	[GameData.Item.PEISTE_SKIN]: {
		name: GameData.Item.PEISTE_SKIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5306 },
			enemies: [GameData.Enemy.BASILISK, GameData.Enemy.ROCKSKIN_PEISTE, GameData.Enemy.SANDSKIN_PEISTE],
		},
		used: [],
	},
	[GameData.Item.BLACK_ALUMEN]: {
		name: GameData.Item.BLACK_ALUMEN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5525 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.URTHS_GIFT, x: 29, y: 23 } }],
		},
		used: [],
	},
	[GameData.Item.SUNSET_WHEAT_FLOUR]: {
		name: GameData.Item.SUNSET_WHEAT_FLOUR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4826 },
			recipes: [
				{
					itemMade: GameData.Item.SUNSET_WHEAT_FLOUR,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 7,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SUNSET_WHEAT, qty: 4 },
						{ item: GameData.Item.FIRE_SHARD, qty: 1 },
					],
				},
			],
			shops: [
				{ shop: GameData.Shop.LITTLEJOHN, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SAHAGIN_VENDOR, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.TABLE_SALT]: {
		name: GameData.Item.TABLE_SALT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4847 },
			recipes: [
				{
					itemMade: GameData.Item.TABLE_SALT,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 7,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ROCK_SALT, qty: 1 },
						{ item: GameData.Item.FIRE_SHARD, qty: 1 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SAHAGIN_VENDOR, cost: [{ price: 2, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.MINERAL_WATER]: {
		name: GameData.Item.MINERAL_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4751 },
			shops: [
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ENGERRAND, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.FRIDURIH, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.JOSSY, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ORHOYOD, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.PASDEVILLET, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SHIRAKASHI, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.TRAVELING_MATERIAL_SUPPLIER, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.BUFFALO_MILK]: {
		name: GameData.Item.BUFFALO_MILK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4753 },
			shops: [
				{ shop: GameData.Shop.ALEHOUSE_WENCH_BLACK_BRUSH, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ENGERRAND, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.FRIDURIH, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.JOSSY, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ORHOYOD, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.PASDEVILLET, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SHIRAKASHI, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.TRAVELING_MATERIAL_SUPPLIER, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.VRAL, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.FLAX]: {
		name: GameData.Item.FLAX,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5346 },
			gathering: [{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.LOWER_PATHS, x: 17, y: 29 } }],
		},
		used: [],
	},
	[GameData.Item.SILVER_ORE]: {
		name: GameData.Item.SILVER_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5113 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.UPPER_PATHS, x: 16, y: 20 } }],
		},
		used: [],
	},
	[GameData.Item.CINNABAR]: {
		name: GameData.Item.CINNABAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5519 },
			gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.HORIZONS_EDGE, x: 24, y: 19 } }],
			shops: [
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ENGERRAND, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ESMENET, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.FRIDURIH, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ORHOYOD, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.PASDEVILLET, cost: [{ price: 3, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.SUNSET_WHEAT]: {
		name: GameData.Item.SUNSET_WHEAT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4824 },
			gathering: [{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.SUMMERFORD, x: 23, y: 19 } }],
			shops: [
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.JOSSY, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.IRON_ORE]: {
		name: GameData.Item.IRON_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5111 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.HORIZONS_EDGE, x: 27, y: 17 } }],
			shops: [
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 18, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 18, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SOEMRWYB, cost: [{ price: 18, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.REINFORCED_SPRUCE_PLYWOOD]: {
		name: GameData.Item.REINFORCED_SPRUCE_PLYWOOD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.REINFORCED_SPRUCE_PLYWOOD,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SPRUCE_PLYWOOD, qty: 1 },
						{ item: GameData.Item.FIELDCRAFT_DEMIMATERIA_III, qty: 2 },
						{ item: GameData.Item.WIND_SHARD, qty: 12 },
						{ item: GameData.Item.ICE_SHARD, qty: 11 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.BALANCED_DARKSTEEL_HOOK]: {
		name: GameData.Item.BALANCED_DARKSTEEL_HOOK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.BALANCED_DARKSTEEL_HOOK,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DARKSTEEL_HOOK, qty: 1 },
						{ item: GameData.Item.FIELDCRAFT_DEMIMATERIA_III, qty: 2 },
						{ item: GameData.Item.FIRE_SHARD, qty: 12 },
						{ item: GameData.Item.EARTH_SHARD, qty: 11 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.REINFOCED_DARKSTEEL_WIRE]: {
		name: GameData.Item.REINFOCED_DARKSTEEL_WIRE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.REINFOCED_DARKSTEEL_WIRE,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DARKSTEEL_WIRE, qty: 1 },
						{ item: GameData.Item.FIELDCRAFT_DEMIMATERIA_III, qty: 2 },
						{ item: GameData.Item.ICE_SHARD, qty: 12 },
						{ item: GameData.Item.EARTH_SHARD, qty: 11 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.CALIBRATED_ROSE_GOLD_COG]: {
		name: GameData.Item.CALIBRATED_ROSE_GOLD_COG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CALIBRATED_ROSE_GOLD_COG,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ROSE_GOLD_COG, qty: 1 },
						{ item: GameData.Item.FIELDCRAFT_DEMIMATERIA_III, qty: 2 },
						{ item: GameData.Item.WIND_SHARD, qty: 12 },
						{ item: GameData.Item.FIRE_SHARD, qty: 11 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.WATERHARDENED_HIPPOGRYPH_STRAP]: {
		name: GameData.Item.WATERHARDENED_HIPPOGRYPH_STRAP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.WATERHARDENED_HIPPOGRYPH_STRAP,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.GRYPHONSKIN_STRAP, qty: 1 },
						{ item: GameData.Item.FIELDCRAFT_DEMIMATERIA_III, qty: 2 },
						{ item: GameData.Item.EARTH_SHARD, qty: 12 },
						{ item: GameData.Item.WIND_SHARD, qty: 11 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.INTRICATE_SILVER_BROCADE]: {
		name: GameData.Item.INTRICATE_SILVER_BROCADE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.INTRICATE_SILVER_BROCADE,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SILVER_BROCADE, qty: 1 },
						{ item: GameData.Item.FIELDCRAFT_DEMIMATERIA_III, qty: 2 },
						{ item: GameData.Item.LIGHTNING_SHARD, qty: 12 },
						{ item: GameData.Item.WIND_SHARD, qty: 11 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.CONCENTRATED_SPIRITS_OF_SALT]: {
		name: GameData.Item.CONCENTRATED_SPIRITS_OF_SALT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONCENTRATED_SPIRITS_OF_SALT,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SPIRITS_OF_SALT, qty: 1 },
						{ item: GameData.Item.FIELDCRAFT_DEMIMATERIA_III, qty: 2 },
						{ item: GameData.Item.WATER_SHARD, qty: 12 },
						{ item: GameData.Item.LIGHTNING_SHARD, qty: 11 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.RICH_TOMATO_RELISH]: {
		name: GameData.Item.RICH_TOMATO_RELISH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RICH_TOMATO_RELISH,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SPICY_TOMATO_RELISH, qty: 1 },
						{ item: GameData.Item.FIELDCRAFT_DEMIMATERIA_III, qty: 2 },
						{ item: GameData.Item.FIRE_SHARD, qty: 12 },
						{ item: GameData.Item.WATER_SHARD, qty: 11 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.TALANS_SEAL_OF_MINING]: {
		name: GameData.Item.TALANS_SEAL_OF_MINING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.TALAN, cost: [{ price: 30, currency: GameData.Item.ANTUMBRAL_ROCK }, { price: 2, currency: GameData.Item.FIELDCRAFT_DEMIMATERIA_III }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.TALANS_SEAL_OF_BOTANY]: {
		name: GameData.Item.TALANS_SEAL_OF_BOTANY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.TALAN, cost: [{ price: 30, currency: GameData.Item.REDOLENT_LOG }, { price: 2, currency: GameData.Item.FIELDCRAFT_DEMIMATERIA_III }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.TALANS_SEAL_OF_FISHING]: {
		name: GameData.Item.TALANS_SEAL_OF_FISHING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.TALAN, cost: [{ price: 1, currency: GameData.Item.OLGOI_KHORKHOI }, { price: 2, currency: GameData.Item.FIELDCRAFT_DEMIMATERIA_III }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MASTERCRAFT_DEMIMATERIA]: {
		name: GameData.Item.MASTERCRAFT_DEMIMATERIA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 800, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_SUPRA, RelicData.Step.SUPRA_ITEMS, RelicData.Task.TASK_2],
				jobs: jobLists.type.utility,
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.SPRUCE_PLYWOOD]: {
		name: GameData.Item.SPRUCE_PLYWOOD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SPRUCE_PLYWOOD,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SPRUCE_LUMBER, qty: 1 },
						{ item: GameData.Item.HORN_GLUE, qty: 2 },
						{ item: GameData.Item.WIND_SHARD, qty: 11 },
						{ item: GameData.Item.ICE_SHARD, qty: 10 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.FIELDCRAFT_DEMIMATERIA_III]: {
		name: GameData.Item.FIELDCRAFT_DEMIMATERIA_III,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 200, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.DARKSTEEL_HOOK]: {
		name: GameData.Item.DARKSTEEL_HOOK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.DARKSTEEL_HOOK,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DARKSTEEL_NUGGET, qty: 2 },
						{ item: GameData.Item.FIRE_SHARD, qty: 11 },
						{ item: GameData.Item.EARTH_SHARD, qty: 10 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.DARKSTEEL_WIRE]: {
		name: GameData.Item.DARKSTEEL_WIRE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.DARKSTEEL_WIRE,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DARKSTEEL_NUGGET, qty: 2 },
						{ item: GameData.Item.ICE_SHARD, qty: 11 },
						{ item: GameData.Item.EARTH_SHARD, qty: 10 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.ROSE_GOLD_COG]: {
		name: GameData.Item.ROSE_GOLD_COG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ROSE_GOLD_COG,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ROSE_GOLD_NUGGET, qty: 2 },
						{ item: GameData.Item.WIND_SHARD, qty: 11 },
						{ item: GameData.Item.FIRE_SHARD, qty: 10 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.GRYPHONSKIN_STRAP]: {
		name: GameData.Item.GRYPHONSKIN_STRAP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.GRYPHONSKIN_STRAP,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.HIPPOGRYPH_LEATHER, qty: 2 },
						{ item: GameData.Item.EARTH_SHARD, qty: 11 },
						{ item: GameData.Item.WIND_SHARD, qty: 10 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.SILVER_BROCADE]: {
		name: GameData.Item.SILVER_BROCADE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SILVER_BROCADE,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SILK_THREAD, qty: 2 },
						{ item: GameData.Item.SILVER_INGOT, qty: 1 },
						{ item: GameData.Item.LIGHTNING_SHARD, qty: 11 },
						{ item: GameData.Item.WIND_SHARD, qty: 10 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.SPIRITS_OF_SALT]: {
		name: GameData.Item.SPIRITS_OF_SALT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SPIRITS_OF_SALT,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.VOLCANIC_ROCK_SALT, qty: 2 },
						{ item: GameData.Item.VITRIOL, qty: 1 },
						{ item: GameData.Item.WATER_SHARD, qty: 11 },
						{ item: GameData.Item.LIGHTNING_SHARD, qty: 10 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.SPICY_TOMATO_RELISH]: {
		name: GameData.Item.SPICY_TOMATO_RELISH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SPICY_TOMATO_RELISH,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DZEMAEL_TOMATO, qty: 1 },
						{ item: GameData.Item.CINNAMON, qty: 1 },
						{ item: GameData.Item.TABLE_SALT, qty: 1 },
						{ item: GameData.Item.DARK_VINEGAR, qty: 1 },
						{ item: GameData.Item.FIRE_SHARD, qty: 11 },
						{ item: GameData.Item.WATER_SHARD, qty: 10 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.ANTUMBRAL_ROCK]: {
		name: GameData.Item.ANTUMBRAL_ROCK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.WELLWICK_WOOD, x: 27, y: 19 }, method: GameData.GatherMethod.QUARRYING, timedNode: true, times: ["2AM"] }] },
		used: [],
	},
	[GameData.Item.REDOLENT_LOG]: {
		name: GameData.Item.REDOLENT_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.GREENTEAR, x: 31, y: 19 }, method: GameData.GatherMethod.LOGGING, timedNode: true, times: ["6AM"] }] },
		used: [],
	},
	[GameData.Item.OLGOI_KHORKHOI]: {
		name: GameData.Item.OLGOI_KHORKHOI,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			fishingHoles: [
				{
					fish: GameData.Fish.OLGOI_KHORKHOI,
					hole: GameData.Fishing.SAGOLII_DUNES,
					weather: GameData.Weather.HEAT_WAVES,
					mooch: [[{ fish: GameData.Fish.STORM_RIDER, bait: [GameData.Bait.SAND_LEECH, GameData.Bait.SAND_GECKO, GameData.Bait.VERSATILE_LURE] }]],
				},
			],
		},
		used: [],
	},
	[GameData.Item.HORN_GLUE]: {
		name: GameData.Item.HORN_GLUE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.HORN_GLUE,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 30,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ALDGOAT_HORN, qty: 2 },
						{ item: GameData.Item.WATER_SHARD, qty: 3 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.ROSE_GOLD_NUGGET]: {
		name: GameData.Item.ROSE_GOLD_NUGGET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ROSE_GOLD_NUGGET,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.GOLD_ORE, qty: 3 },
						{ item: GameData.Item.COPPER_ORE, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 3 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.HIPPOGRYPH_LEATHER]: {
		name: GameData.Item.HIPPOGRYPH_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.HIPPOGRYPH_LEATHER,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.HIPPOGRYPH_SKIN, qty: 1 },
						{ item: GameData.Item.BLACK_ALUMEN, qty: 1 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 3 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.SILK_THREAD]: {
		name: GameData.Item.SILK_THREAD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SILK_THREAD,
					qtyMade: 2,
					crafter: Job.WVR,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SILKWORM_COCOON, qty: 2 },
						{ item: GameData.Item.EFFERVESCENT_WATER, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 3 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.SILVER_INGOT]: {
		name: GameData.Item.SILVER_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SILVER_INGOT,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 23,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SILVER_ORE, qty: 3 },
						{ item: GameData.Item.WIND_SHARD, qty: 2 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.VOLCANIC_ROCK_SALT]: {
		name: GameData.Item.VOLCANIC_ROCK_SALT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.RAINCATCHER_GULLY, x: 21, y: 33 }, method: GameData.GatherMethod.QUARRYING, timedNode: true, times: ["5PM"] }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.DZEMAEL_TOMATO]: {
		name: GameData.Item.DZEMAEL_TOMATO,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.RAINCATCHER_GULLY, x: 16, y: 28 }, method: GameData.GatherMethod.HARVESTING, timedNode: true, times: ["1PM"] }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.CINNAMON]: {
		name: GameData.Item.CINNAMON,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ENGERRAND, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.FRIDURIH, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.JOSSY, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ORHOYOD, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.PASDEVILLET, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SAHAGIN_VENDOR, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SHIRAKASHI, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.TRAVELING_MATERIAL_SUPPLIER, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.VRAL, cost: [{ price: 4, currency: GameData.Currency.GIL }] },
			],
			gathering: [{ found: { location: GameData.MapLocation.TREESPEAK, x: 29, y: 26 }, method: GameData.GatherMethod.LOGGING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.DARK_VINEGAR]: {
		name: GameData.Item.DARK_VINEGAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.DARK_VINEGAR,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 31,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.NOBLE_GRAPES, qty: 4 },
						{ item: GameData.Item.FIRE_SHARD, qty: 3 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.ALDGOAT_HORN]: {
		name: GameData.Item.ALDGOAT_HORN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.MOURNING_BILLY, GameData.Enemy.MOURNING_NANNY, GameData.Enemy.MYOTRAGUS_BILLY, GameData.Enemy.MYOTRAGUS_NANNY],
			shops: [{ shop: GameData.Shop.KOBOLD_VENDOR, cost: [{ price: 238, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.GOLD_ORE]: {
		name: GameData.Item.GOLD_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.WELLWICK_WOOD, x: 28, y: 21 }, method: GameData.GatherMethod.MINING, timedNode: true, times: ["9AM"] }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.COPPER_ORE]: {
		name: GameData.Item.COPPER_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AISTAN, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ENGERRAND, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.FRIDURIH, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ORHOYOD, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.PASDEVILLET, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SMYDHAEMR, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SOEMRWYB, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
			],
			gathering: [
				{ found: { location: GameData.MapLocation.HAMMERLEA, x: 27, y: 26 }, method: GameData.GatherMethod.MINING },
				{ found: { location: GameData.MapLocation.SPINELESS_BASIN, x: 19, y: 26 }, method: GameData.GatherMethod.MINING },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.HIPPOGRYPH_SKIN]: {
		name: GameData.Item.HIPPOGRYPH_SKIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.HIPPOGRYPH],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.SILKWORM_COCOON]: {
		name: GameData.Item.SILKWORM_COCOON,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.NINE_IVIES, x: 22, y: 26 }, method: GameData.GatherMethod.HARVESTING, timedNode: true, times: ["1AM"] }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.NOBLE_GRAPES]: {
		name: GameData.Item.NOBLE_GRAPES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.OAKWOOD, x: 14, y: 25 }, method: GameData.GatherMethod.HARVESTING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.PETRIFIED_ORB_HQ]: {
		name: GameData.Item.PETRIFIED_ORB_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PETRIFIED_ORB_HQ,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.URUSHI, qty: 3 },
						{ item: GameData.Item.PETRIFIED_LOG, qty: 1 },
						{ item: GameData.Item.SCARLET_SAP, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.MUMMERS_DAGGERS_HQ]: {
		name: GameData.Item.MUMMERS_DAGGERS_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.MUMMERS_DAGGERS_HQ,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.COMPOSITE_WHETSTONE, qty: 3 },
						{ item: GameData.Item.SCHEELITE, qty: 1 },
						{ item: GameData.Item.FERBERITE, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.LAPDOG_COLLAR_BELL_HQ]: {
		name: GameData.Item.LAPDOG_COLLAR_BELL_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.LAPDOG_COLLAR_BELL_HQ,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.HEAT_RESISTANT_PLASTER, qty: 3 },
						{ item: GameData.Item.SCHEELITE, qty: 1 },
						{ item: GameData.Item.FERBERITE, qty: 1 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 3 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.FLUORITE_LENS_HQ]: {
		name: GameData.Item.FLUORITE_LENS_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.FLUORITE_LENS_HQ,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.CLEAR_FLUORITE, qty: 3 },
						{ item: GameData.Item.EMERY, qty: 1 },
						{ item: GameData.Item.BASILISK_WHETSTONE, qty: 1 },
						{ item: GameData.Item.SILTSTONE_WHETSTONE, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.PATENT_LEATHER_HQ]: {
		name: GameData.Item.PATENT_LEATHER_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PATENT_LEATHER_HQ,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.LAMPBLACK_LINSEED_OIL, qty: 3 },
						{ item: GameData.Item.SAURIAN_SKIN, qty: 1 },
						{ item: GameData.Item.SHROUD_TEA_LEAVES, qty: 1 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.CAMLET_HQ]: {
		name: GameData.Item.CAMLET_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CAMLET_HQ,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.CAMEL_HAIR, qty: 3 },
						{ item: GameData.Item.CASHMERE_FLEECE, qty: 1 },
						{ item: GameData.Item.DILUTED_VITRIOL, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 3 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.ENCHANTED_QUICKSILVER_HQ]: {
		name: GameData.Item.ENCHANTED_QUICKSILVER_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ENCHANTED_QUICKSILVER_HQ,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.BLACK_CINNABAR, qty: 3 },
						{ item: GameData.Item.RAZIQSAND, qty: 1 },
						{ item: GameData.Item.TARANTULA, qty: 2 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.DUCK_BROTH_HQ]: {
		name: GameData.Item.DUCK_BROTH_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.DUCK_BROTH_HQ,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DUCK_BONES, qty: 3 },
						{ item: GameData.Item.CANARD_BREAST, qty: 1 },
						{ item: GameData.Item.THYME, qty: 1 },
						{ item: GameData.Item.WILD_ONION, qty: 4 },
						{ item: GameData.Item.GARLEAN_GARLIC, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.TALANS_SEAL_OF_MINING_MASTERY]: {
		name: GameData.Item.TALANS_SEAL_OF_MINING_MASTERY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.TALAN, cost: [{ price: 30, currency: GameData.Item.ANTUMBRAL_ROCK }, { price: 15, currency: GameData.Item.MAGICKED_OILCLOTH }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.TALANS_SEAL_OF_BOTANY_MASTERY]: {
		name: GameData.Item.TALANS_SEAL_OF_BOTANY_MASTERY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.TALAN, cost: [{ price: 30, currency: GameData.Item.REDOLENT_LOG }, { price: 15, currency: GameData.Item.BAMBOO_PAPER }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.TALANS_SEAL_OF_FISHING_MASTERY]: {
		name: GameData.Item.TALANS_SEAL_OF_FISHING_MASTERY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.TALAN, cost: [{ price: 10, currency: GameData.Item.GIGANT_CLAM }, { price: 15, currency: GameData.Item.GLACIER_CRYSTAL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MOONSTONE]: {
		name: GameData.Item.MOONSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 4000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 4000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 4000, currency: GameData.Currency.COMPANY_SEAL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_LUCIS, RelicData.Part.TOOL_LUCIS, RelicData.Step.LUCIS_ITEMS, RelicData.Task.TASK_2],
				jobs: jobLists.type.utility,
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.URUSHI]: {
		name: GameData.Item.URUSHI,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 600, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 600, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 600, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.PETRIFIED_LOG]: {
		name: GameData.Item.PETRIFIED_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.IXALI_VENDOR, cost: [{ price: 7, currency: GameData.Currency.IXALI_OAKNOT }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.SCARLET_SAP]: {
		name: GameData.Item.SCARLET_SAP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.ALDER_SPRINGS, x: 16, y: 28 }, method: GameData.GatherMethod.LOGGING, timedNode: true, times: ["3AM"] }] },
		used: [],
	},
	[GameData.Item.COMPOSITE_WHETSTONE]: {
		name: GameData.Item.COMPOSITE_WHETSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.SCHEELITE]: {
		name: GameData.Item.SCHEELITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.IXALI_VENDOR, cost: [{ price: 7, currency: GameData.Currency.IXALI_OAKNOT }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.FERBERITE]: {
		name: GameData.Item.FERBERITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.RAUBAHNS_PUSH, x: 16, y: 20 }, method: GameData.GatherMethod.MINING, timedNode: true, times: ["3AM"] }] },
		used: [],
	},
	[GameData.Item.HEAT_RESISTANT_PLASTER]: {
		name: GameData.Item.HEAT_RESISTANT_PLASTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.CLEAR_FLUORITE]: {
		name: GameData.Item.CLEAR_FLUORITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.EMERY]: {
		name: GameData.Item.EMERY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.IXALI_VENDOR, cost: [{ price: 7, currency: GameData.Currency.IXALI_OAKNOT }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.SILTSTONE_WHETSTONE]: {
		name: GameData.Item.SILTSTONE_WHETSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SILTSTONE_WHETSTONE,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 30,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SILTSTONE, qty: 2 },
						{ item: GameData.Item.WIND_SHARD, qty: 3 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.LAMPBLACK_LINSEED_OIL]: {
		name: GameData.Item.LAMPBLACK_LINSEED_OIL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.SAURIAN_SKIN]: {
		name: GameData.Item.SAURIAN_SKIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.IXALI_VENDOR, cost: [{ price: 7, currency: GameData.Currency.IXALI_OAKNOT }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.SHROUD_TEA_LEAVES]: {
		name: GameData.Item.SHROUD_TEA_LEAVES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.SORREL_HAVEN, x: 16, y: 20 }, method: GameData.GatherMethod.HARVESTING, timedNode: true, times: ["2AM"] }] },
		used: [],
	},
	[GameData.Item.CAMEL_HAIR]: {
		name: GameData.Item.CAMEL_HAIR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.CASHMERE_FLEECE]: {
		name: GameData.Item.CASHMERE_FLEECE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.IXALI_VENDOR, cost: [{ price: 7, currency: GameData.Currency.IXALI_OAKNOT }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.DILUTED_VITRIOL]: {
		name: GameData.Item.DILUTED_VITRIOL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.DILUTED_VITRIOL,
					qtyMade: 9,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.FILTERED_WATER, qty: 9 },
						{ item: GameData.Item.VITRIOL, qty: 6 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.BLACK_CINNABAR]: {
		name: GameData.Item.BLACK_CINNABAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.RAZIQSAND]: {
		name: GameData.Item.RAZIQSAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 1500, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.IXALI_VENDOR, cost: [{ price: 7, currency: GameData.Currency.IXALI_OAKNOT }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.TARANTULA]: {
		name: GameData.Item.TARANTULA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.LOWER_PATHS, x: 17, y: 30 }, method: GameData.GatherMethod.LOGGING }] },
		used: [],
	},
	[GameData.Item.DUCK_BONES]: {
		name: GameData.Item.DUCK_BONES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.CANARD_BREAST]: {
		name: GameData.Item.CANARD_BREAST,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 30, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 30, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 30, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.IXALI_VENDOR, cost: [{ price: 1, currency: GameData.Currency.IXALI_OAKNOT }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.THYME]: {
		name: GameData.Item.THYME,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.LOWER_PATHS, x: 21, y: 29 }, method: GameData.GatherMethod.HARVESTING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.WILD_ONION]: {
		name: GameData.Item.WILD_ONION,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [{ shop: GameData.Shop.JOSSY, cost: [{ price: 7, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 7, currency: GameData.Currency.GIL }] }],
			gathering: [{ found: { location: GameData.MapLocation.NOPHICAS_WELLS, x: 24, y: 23 }, method: GameData.GatherMethod.HARVESTING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.GARLEAN_GARLIC]: {
		name: GameData.Item.GARLEAN_GARLIC,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.JOSSY, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SAHAGIN_VENDOR, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
			],
			gathering: [{ found: { location: GameData.MapLocation.NOPHICAS_WELLS, x: 24, y: 23 }, method: GameData.GatherMethod.HARVESTING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.MAGICKED_OILCLOTH]: {
		name: GameData.Item.MAGICKED_OILCLOTH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.BAMBOO_PAPER]: {
		name: GameData.Item.BAMBOO_PAPER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.GIGANT_CLAM]: {
		name: GameData.Item.GIGANT_CLAM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.GIGANT_CLAM, hole: GameData.Fishing.SOUTH_BLOODSHORE, bait: [GameData.Bait.HEAVY_STEEL_JIG], time: "11PM-2AM" }] },
		used: [],
	},
	[GameData.Item.GLACIER_CRYSTAL]: {
		name: GameData.Item.GLACIER_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 600, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 50, currency: GameData.Currency.ALLIED_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.SILTSTONE]: {
		name: GameData.Item.SILTSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.OAKWOOD, x: 13, y: 26 }, method: GameData.GatherMethod.QUARRYING }] },
		used: [],
	},
	[GameData.Item.FILTERED_WATER]: {
		name: GameData.Item.FILTERED_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 20, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 20, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 20, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.IXALI_VENDOR, cost: [{ price: 1, currency: GameData.Currency.IXALI_OAKNOT }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
} satisfies Partial<{ [key in GameData.Item]: Info.Item }>;
